import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@babel/polyfill'
import 'intersection-observer' // Optional
import Vue from 'vue'
import Router from 'vue-router'
import RebateForm from '@/components/rebateFormEntry'

import RebateConfirmation from '@/components/RebateEntryConfirmation'
import Vuesax from 'vuesax'
import VueFormGenerator from "vue-form-generator";
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import polyfillLibrary from 'polyfill-library';

Vue.use(BootstrapVue)
Vue.use(Router)
Vue.use(Vuesax)
Vue.use(VueFormGenerator)

// const polyfillBundle = polyfillLibrary.getPolyfillString({
// 	uaString: 'Mozilla/5.0 (Windows; U; MSIE 7.0; Windows NT 6.0; en-US)',
// 	minify: true,
// 	features: {
// 		'es6': { flags: ['gated'] }
// 	}
// }).then(function(bundleString) {
// 	console.log(bundleString);
// });

export default new Router({
  routes: [
    {
      path: '/',
      name: 'RebateForm',
      component: RebateForm
    },
    {
      path: '/confirmation',
      name: 'RebateConfirmation',
      component: RebateConfirmation
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js